'use client'

import Link from 'next/link'
import { Suspense, useEffect, useState, useRef } from 'react'
import MapSection from '@/travelmde/components/Home/MapSection'

const GayMapSection = ({ lang, viewMore }) => {
  const [isVisible, setIsVisible] = useState(false)
  const mapRef = useRef(null)

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setIsVisible(true)
          observer.disconnect()
        }
      },
      {
        rootMargin: '100px', // Load map when it's 100px from viewport
      },
    )

    if (mapRef.current) {
      observer.observe(mapRef.current)
    }

    return () => observer.disconnect()
  }, [])

  return (
    <section id="map__section">
      <div className="map__main container">
        <div id="heading__bar" className="event__topbar dflex">
          <h2 className="main__heading">
            {' '}
            Travel <span>M Gay Map</span>
          </h2>
          <Link href={`/${lang}/main-category/gay-map/1/default`} className="view__more">
            {viewMore}
          </Link>
        </div>
        <div ref={mapRef}>
          {isVisible ? (
            <MapSection lang={lang} fetchObject={''} />
          ) : (
            <div
              className="map__placeholder"
              style={{
                minHeight: '500px',
                background: '#f5f5f5',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
              }}
            >
              <div>Loading map...</div>
            </div>
          )}
        </div>
      </div>
    </section>
  )
}

export default GayMapSection
